import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import Menu from './components/menu';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Footer from './Pages/footer';
import Disposición from './components/disposición';
import { Analytics } from '@vercel/analytics/react';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <div className='contenitore scrollbar-none'>
    <BrowserRouter>
    

    <App/>
    <Footer />
    <Analytics />
    </BrowserRouter></div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
